import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users UPDATE mutations on APPS
  subscribe: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { appId } = requestParams;
    const mutationPrefix = 'entities/apps/subscribe';

    commit(`${mutationPrefix}Pending`, appId, { root: true });

    return api.subscribe(requestParams)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, appId, { root: true });

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id: appId }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id: appId }));
  },

  // Uses UPDATE mutations on APPS
  cancelSubscription: (context, appId) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'entities/apps/cancelSubscription';

    commit(`${mutationPrefix}Pending`, appId, { root: true });

    return api.cancelSubscription(appId)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, appId, { root: true });

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id: appId }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id: appId }));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/appMembership/actions.js